<template>
  <div :id="dropdownId" class="dropdown">
    <div data-toggle="dropdown" v-tooltip.bottom="'Send test email <br/><small><i>Note: hyperlinks to any landing page elements of this campaign will redirect to your website until the time of launch</i></small>'">
      <button
        class="btn btn-default dropdown-toggle"
        type="button"
        :id="buttonId"
        data-test="step-test-email-button"
        aria-haspopup="true"
        aria-expanded="true"
      >
        <span>Send Test</span>
        <span class="caret"></span>
      </button>
    </div>
    <div class="dropdown-menu dropdown-menu-right p-4" :aria-labelledby="buttonId" @click="onDropdownMenuClick($event)">
      <step-email-test-form :sending="sending" :step="step" :user="user" @send="onSend($event)"></step-email-test-form>
    </div>
  </div>
</template>

<script>
import {sendCampaignStepTestEmail} from '../../../utility/api/campaign/sendCampaignStepTestEmail';
import StepEmailTestForm from './StepEmailTestForm';

export default {
  name: 'send-test-email-button',
  components: {StepEmailTestForm},
  props: {
    campaign: {
      type: Object,
      required: true,
    },
    step: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      sending: false,
    };
  },
  computed: {
    buttonId() {
      return `step-${this.step.id}-test-email-button`;
    },
    dropdownId() {
      return `step-${this.step.id}-test-email-dropdown`;
    },
  },
  methods: {
    onDropdownMenuClick(event) {
      event.stopPropagation();
    },
    async onSend(data) {
      this.sending = true;

      try {
        await sendCampaignStepTestEmail(this.campaign.id, this.step.id, {
          email: data.email,
          first_name: data.firstName,
          last_name: data.lastName,
        });

        $.notify('Email has been sent.', 'success');
        $(`#${this.buttonId}`).click();
      } catch (error) {
        $.notify('Failed to send an email.', 'error');
      }

      this.sending = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdown-toggle {
  padding: 5px 12px;
}
</style>
